import { Box, Flex, Grid, Skeleton, Spinner } from '@chakra-ui/react';
import { ethers } from 'ethers';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CARTRIDGE_ABI } from 'src/contracts/token/abi';
import { useBlockchainProvider } from '../../../../providers/Blockchain/blockchainProvider';
import { nFormatter } from 'src/utils/utils';
import { DistributionChart } from './DistributionChart/distributionChart';
import { config } from 'src/config';

export const ChartsTab = ({ address, creator }: { address: string; creator: string }) => {
	const { t } = useTranslation();
	const { contracts } = useBlockchainProvider();

	const cartridgeContract = useMemo(() => {
		const provider = new ethers.providers.Web3Provider(window.ethereum, 'any');
		if (provider) {
			const signer = provider.getSigner();
			return new ethers.Contract(address, CARTRIDGE_ABI, signer);
		} else {
			return null;
		}
	}, [window.ethereum]);

	return (
		<Flex flexDir="column">
			<DistributionChart
				address={address}
				creator={creator}
				storeContract={contracts.hashupStoreV2}
				cartridgeContract={cartridgeContract}
			/>
		</Flex>
	);
};
